import React from 'react';
import { t } from '../../services/i18nService';

import styles from './testOverview.scss';

const ManualStartVerifier = () => (
    <div className={`${styles.actionBox}`}>
        <i className="fa fa-clock-o inline-icon" />
        <span className={styles.waitForStartMessage}>
            {t('childTest.waitForInvigilatorToStartTest')}
        </span>
    </div>
);

export default ManualStartVerifier;
